import VARIABLES from "./variables";

const projectSpecific = {
  portalWell: {
    default: {
      border: VARIABLES.COLORS.enchantedForestGreen,
      background: VARIABLES.COLORS.enchantedForestGreen
    },
    pill: {
      border: VARIABLES.COLORS.lighterGray,
      background: VARIABLES.COLORS.lighterGray
    },
    formNote: {
      border: VARIABLES.COLORS.enchantedForestGreen,
      background: VARIABLES.COLORS.teaGreen
    },
    white: {
      border: VARIABLES.COLORS.enchantedForestGreen,
      background: VARIABLES.COLORS.white
    }
  },
  accordion: {
    headColor: VARIABLES.COLORS.white, // 1
    headBackgroundOne: VARIABLES.COLORS.themeBody, // 0
    headBackgroundTwo: VARIABLES.COLORS.mantisGreen, // 4
    panelBackground: VARIABLES.COLORS.themeBody, // 2
  },
  ballBreadCrumb: {
    main: VARIABLES.COLORS.orange, // 3
    active: VARIABLES.COLORS.enchantedForestGreen, // 0, 2
    completeMobile: VARIABLES.COLORS.mantisGreen, // 1
    color: VARIABLES.COLORS.gray, // 4
  },
};

export { projectSpecific };
